import { render, staticRenderFns } from "./CityWiseGender.vue?vue&type=template&id=374e867f&scoped=true&"
import script from "./CityWiseGender.vue?vue&type=script&lang=js&"
export * from "./CityWiseGender.vue?vue&type=script&lang=js&"
import style0 from "./CityWiseGender.vue?vue&type=style&index=0&id=374e867f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374e867f",
  null
  
)

export default component.exports